<template src="./drivertag.html"></template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  props: ["Driver"],
  filters: {},
  data() {
    return {
      firstLetter: "",
      secondLetter: "",
      driverImage: "",
    };
  },
  mounted() {},
  methods: {
    checkDate(expDate) {
      // set current date
      var currentDate = new Date();
      var licenceExpDate = new Date(expDate);
      var isLicenceExpired = false;
      if (licenceExpDate < currentDate) {
        isLicenceExpired = true;
      }
      return isLicenceExpired;
    },
  },
};
</script>
